export function shouldShowQuestion(question, answers) {
  if (!question.conditional) return true;

  const { dependsOn } = question;
  if (!dependsOn) return true;

  const dependentAnswer = answers[dependsOn.questionId];

  // Check for exact value match
  if (dependsOn.value) {
    return dependentAnswer === dependsOn.value;
  }

  // Check for array includes (for checkbox questions)
  if (dependsOn.includesValue) {
    return Array.isArray(dependentAnswer) && dependentAnswer.includes(dependsOn.includesValue);
  }

  return true;
}

export function isDisqualifyingAnswer(question, answer) {
  if (!question.options) return false;

  const selectedOption = question.options.find(opt => opt.value === answer);
  return selectedOption?.disqualifying === true;
}

export function getVisibleQuestions(allQuestions, answers) {
  return allQuestions.filter(q => shouldShowQuestion(q, answers));
}

export function calculateProgress(currentPage, totalPages) {
  return Math.round((currentPage / totalPages) * 100);
}
